import { createFileRoute } from '@tanstack/react-router'
import MySpeakers from '../pages/(Admin)/MySpeakers/MySpeakers'
import AppLayout from '../layouts/AppLayout'

export const Route = createFileRoute('/my-speakers')({
  component: MySpeakersComponent,
})

function MySpeakersComponent() {
  return (
    <AppLayout>
      <MySpeakers />
    </AppLayout>
  )
}
